import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-showclient',
  templateUrl: './showclient.component.html',
  styleUrls: ['./showclient.component.scss']
})
export class ShowclientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
